import { DatabaseService } from 'src/app/services/database.service';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/lazy';
import { ObserverService } from 'src/app/services/observer.service';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Injectable()

export class ParkedCartLegacyService {

    constructor(
        public alertController: AlertController,
        private observerService: ObserverService,
        private databaseService: DatabaseService,
        private router: Router,
        private authService: AuthService,
        private apiService: APIService
    ) { }

    addParkedCart(parked_cart) {
        return new Promise<void>((resolve, reject) => {
            if(parked_cart) {
                parked_cart.cart.payments = [];
                if(parked_cart.cart['person'] && parked_cart.cart.person["credit_details"]) {
                    delete parked_cart.cart.person.credit_details;
                }
                if(parked_cart.cart["organisation"] && parked_cart.cart.organisation["credit_details"]) {
                    delete parked_cart.cart.organisation.credit_details;
                }
                this.databaseService.parked_cart_legacy.add(parked_cart).then(() => {
                    this.observerService.publish("parked_cart_added", parked_cart);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
            } 
            else {
                reject();
            }
        });
    }

    deleteParkedCart(cart_id) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.parked_cart_legacy.delete(cart_id).then(() => {
                this.observerService.publish("parked_cart_deleted", cart_id);
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    deleteParkedCarts() {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.parked_cart_legacy.clear().then(() => {
                this.observerService.publish("parked_carts_deleted", null);
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    getParkedCart(parked_cart_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.parked_cart_legacy.get(parked_cart_id).then((parked_cart) => {
                resolve(parked_cart);
            })
            .catch(() => {
                reject();
            });
        });
    }

    getParkedCarts() {
        return new Promise((resolve, reject) => {
            this.databaseService.parked_cart_legacy.toArray().then((parked_carts) => {
                resolve(parked_carts);
            })
            .catch(() => {
                reject();
            });
        });
    }

    updateParkedCart(parked_cart) {
        return new Promise<void>((resolve, reject) => {
            let parked_cart_id = parked_cart.cart.parked_cart_id;
            delete parked_cart.cart.parked_cart_id;
            parked_cart.cart.payments = [];
            this.databaseService.parked_cart_legacy.update(parked_cart_id, {date: parked_cart['date'], user_id: parked_cart['user_id'], cart: parked_cart['cart']}).then(() => {
                // NOTE: this publish() event fires twice for no obvious reason
                this.observerService.publish("parked_cart_updated", parked_cart_id);
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    updateParkedCartLegacyData(parked_cart) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.parked_cart_legacy.update(parked_cart['id'], parked_cart).catch(() => {
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ['OK'],
        });
        await alert.present();
    }

}
